import { put, takeLatest } from '@redux-saga/core/effects';

import { SIGNOUT } from 'redux/sagas/actions/authentication';
import { RESET_STATE as RESET_STATE_ACCOUNT } from 'redux/slices/account';
import { RESET_STATE as RESET_STATE_AUTH } from 'redux/slices/authentication';
import { RESET_STATE as RESET_MODALS } from 'redux/slices/modals';
import { RESET_STATE as RESET_PEOPLE } from 'redux/slices/people';

function* logout() {
  try {
    yield put(RESET_STATE_ACCOUNT());
    yield put(RESET_STATE_AUTH());
    yield put(RESET_MODALS());
    yield put(RESET_PEOPLE());
  } catch (err) {
    console.log('saga > logout', err);
  }
}

function* logoutWatch() {
  yield takeLatest(SIGNOUT._SUCCESS, logout);
}

export default [logoutWatch()];
